import { render } from "./AddDebtorDialog.vue?vue&type=template&id=6d43b52a"
import script from "./AddDebtorDialog.vue?vue&type=script&lang=js"
export * from "./AddDebtorDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__